import { createContext } from 'react';
import { AlertDialog } from './AlertDialog';

export type ShowAlertDialogContextType = {
  showAlertDialog: (arg: Omit<React.ComponentProps<typeof AlertDialog>, 'onClose'>) => void;
};
export const ShowAlertDialogContext = createContext<ShowAlertDialogContextType>({
  showAlertDialog: () => {},
});
